import React from 'react'
import KeyfigureId from './fields/KeyfigureId'
import Id from './fields/Id'
import Name from './fields/Name'
import TranslateFields from '../../../../../../components/Form/TranslateFields'
import Source from './fields/Source'
import FormulaId from './fields/FormulaId'
import { Authorizable } from '../../../../../../utils/Authorizable/types'
import { RowType } from '../../../../../../redux/context/customReports/typesVariable'
import { SectionType } from '../../../../../../redux/context/customReports/typesSection'
import FormulaIdField from '../../../../../../features/formulas/components/formItems/FormulaIdField'
import FormulaTypeField from '../../../../../../features/formulas/components/formItems/FormulaTypeField'
import FormulaAddFunctionAndSourceWrapper from '../../../../../../features/formulas/components/formItems/FormulaAddFunctionAndSourceWrapper'

// Define a single field configuration
export interface FieldConfig extends Authorizable {
  key?: string
  element: React.ReactElement
}

export type SectionConfig = Partial<Record<RowType, GroupConfig>>

export interface GroupConfig {
  basic: string[]
  parameters: string[]
  styles: string[]
}

export type MasterConfig = Partial<Record<SectionType, SectionConfig>>

export const keyValueConfig: { [key: string]: FieldConfig } = {
  id: { element: <Id /> },
  keyFigureId: { element: <KeyfigureId /> },
  formulaId: { element: <FormulaId /> },
  source: { element: <Source /> },
  name: { element: <Name /> },
  translateFields: { element: <TranslateFields /> },
  // Formula form items
  formulaId_field: { element: <FormulaIdField /> },
  formulaType: { element: <FormulaTypeField /> },
  formulaAddFunctionAndSource: { element: <FormulaAddFunctionAndSourceWrapper /> }
}

export const sourceBasicConfig = [
  'id',
  'formulaId_field',
  'name',
  'translateFields',
  'formulaType',
  'formulaAddFunctionAndSource'
]

export const masterConfig: MasterConfig = {
  table: {
    formula: {
      basic: ['id', 'formulaId', 'name', 'translateFields'],
      parameters: ['dimension', 'month', 'dataType', 'offset', 'showEmptyRows', 'expandable'],
      styles: [
        'fontWeight',
        'fontStyle',
        'decimals',
        'displayScale',
        'showScaleSuffix',
        'indentLevel',
        'thresholdValueSetting',
        'color'
      ]
    },
    keyFigure: {
      basic: ['id', 'keyFigureId', 'name', 'translateFields'],
      parameters: ['dimension', 'month', 'dataType', 'offset', 'showEmptyRows', 'expandable'],
      styles: [
        'fontStyle',
        'fontWeight',
        'decimals',
        'displayScale',
        'showScaleSuffix',
        'indentLevel',
        'thresholdValueSetting',
        'color'
      ]
    },
    source: {
      basic: sourceBasicConfig,
      parameters: ['dimension', 'month', 'dataType', 'offset', 'showEmptyRows', 'expandable'],
      styles: [
        'fontStyle',
        'fontWeight',
        'decimals',
        'displayScale',
        'showScaleSuffix',
        'indentLevel',
        'thresholdValueSetting',
        'color'
      ]
    },
    empty: { basic: ['id'], parameters: ['showEmptyRows'], styles: ['color'] },
    title: {
      basic: ['id', 'name', 'translateFields'],
      parameters: ['showEmptyRows'],
      styles: ['fontStyle', 'fontWeight', 'indentLevel', 'color']
    }
  },
  graph: {
    formula: {
      basic: ['id', 'formulaId', 'name', 'translateFields'],
      parameters: ['dimension', 'month', 'dataType', 'offset', 'showEmptyRows'],
      styles: [
        'fontStyle',
        'fontWeight',
        'decimals',
        'displayScale',
        'showScaleSuffix',
        'indentLevel',
        'seriesStyleFields'
      ]
    },
    keyFigure: {
      basic: ['id', 'keyFigureId', 'name', 'translateFields'],
      parameters: ['dimension', 'month', 'dataType', 'offset', 'showEmptyRows'],
      styles: [
        'fontStyle',
        'fontWeight',
        'decimals',
        'displayScale',
        'showScaleSuffix',
        'indentLevel',
        'seriesStyleFields'
      ]
    },
    source: {
      basic: sourceBasicConfig,
      parameters: ['dimension', 'month', 'dataType', 'offset', 'showEmptyRows'],
      styles: [
        'fontStyle',
        'fontWeight',
        'decimals',
        'displayScale',
        'showScaleSuffix',
        'indentLevel',
        'seriesStyleFields'
      ]
    }
  },
  infobox: {},
  pie: {
    formula: {
      basic: ['id', 'formulaId', 'name', 'translateFields'],
      parameters: ['dimension', 'month', 'dataType', 'offset', 'showEmptyRows'],
      styles: ['fontStyle', 'fontWeight', 'decimals', 'displayScale', 'showScaleSuffix', 'indentLevel', 'color']
    },
    keyFigure: {
      basic: ['id', 'keyFigureId', 'name', 'translateFields'],
      parameters: ['dimension', 'month', 'dataType', 'offset', 'showEmptyRows'],
      styles: ['fontStyle', 'fontWeight', 'decimals', 'displayScale', 'showScaleSuffix', 'indentLevel', 'color']
    },
    source: {
      basic: sourceBasicConfig,
      parameters: ['dimension', 'month', 'dataType', 'offset', 'showEmptyRows'],
      styles: ['fontStyle', 'fontWeight', 'decimals', 'displayScale', 'showScaleSuffix', 'indentLevel', 'color']
    }
  }
}
